<template>
  <pui-flex class="poster-edit-svg-viewer" flex="1">
    <pui-flex
      v-if="fontsError"
      class="preview-fonts-error"
      flex="1"
      direction="column"
      alignItems="center"
    >
      <i class="mdi mdi-alert error-icon" />
      <i18n path="poster.demands.editing.error.fonts.primary"></i18n>
      <i18n path="poster.demands.editing.error.fonts.secondary">
        <template #clickToReload>
          <span @click="emit('reloadFromFontsError')" class="reload-button">{{
            $t('poster.demands.editing.error.fonts.click_to_reload')
          }}</span>
        </template>
      </i18n>
    </pui-flex>

    <pui-document-viewer
      ref="viewer"
      v-else
      :template="currentTemplate"
      :bindings="values"
      :types="valuesTypes"
    />
  </pui-flex>
</template>

<script>
import { posterViewerMixin } from './posterViewerMixin';

export default {
  name: 'pui-poster-default-viewer',
  mixins: [posterViewerMixin],
  methods: {
    // Exposed
    /**
     * Sets showAllPrintables from the outside
     * Example: show all printables to render svg/thumbnail
     */
    setShowAllPrintables(showAllPrintables) {
      if (this.$refs.viewer) {
        this.$refs.viewer.setShowAllPrintables(showAllPrintables);
      }
    },
    /**
     * @returns {Element} the main svg element of the poster
     */
    getSvgEl() {
      return this.$refs.viewer ? this.$refs.viewer.getSvgEl() : null;
    },
  },
};
</script>
